import { Brain, GitBranch, Sparkles, Activity } from "lucide-react";

interface StatsData {
  totalChunks: number;
  totalConnections: number;
  newThisWeek: number;
  intelligenceScore: number;
}

interface HeartbeatStatsProps {
  stats: StatsData | null;
  isLoading: boolean;
}

const STAT_CARDS = [
  { key: "totalChunks", label: "Knowledge entries", icon: Brain },
  { key: "totalConnections", label: "Connections", icon: GitBranch },
  { key: "newThisWeek", label: "New This Week", icon: Sparkles },
  { key: "intelligenceScore", label: "Intelligence Score", icon: Activity },
] as const;

export function HeartbeatStats({ stats, isLoading }: HeartbeatStatsProps) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="heartbeat-stats">
      {STAT_CARDS.map(card => (
        <div
          key={card.key}
          className="bg-white rounded-xl border border-gray-200 px-4 py-3 flex items-center gap-3"
          data-testid={`stat-card-${card.key}`}
        >
          <div
            className="h-9 w-9 rounded-lg flex items-center justify-center flex-shrink-0 bg-gray-100"
          >
            <card.icon className="h-4.5 w-4.5 text-gray-400" />
          </div>
          <div className="min-w-0">
            <p className="text-[11px] font-medium text-gray-500 uppercase tracking-wide">{card.label}</p>
            {isLoading ? (
              <div className="h-6 w-12 bg-gray-100 animate-pulse rounded mt-0.5" />
            ) : (
              <p className="text-xl font-bold text-gray-900">
                {stats ? (card.key === "intelligenceScore" ? `${stats[card.key]}%` : stats[card.key]) : "—"}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
